import { motion } from "motion/react";
import { useEffect, useRef, useState } from "react";

interface FadeInComponentProps {
  children: React.ReactNode;
  threshold?: number;
  rootMargin?: string;
  duration?: number;
  delay?: number;
  className?: string;
  style?: React.CSSProperties;
}

const FadeInComponent: React.FC<FadeInComponentProps> = ({
  children,
  threshold = 0.1,
  rootMargin = "0px",
  duration = 0.6,
  delay = 0,
  className = "",
  style,
}) => {
  const [inView, setInView] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!ref.current) {
      return;
    }
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(ref.current as Element);
        }
      },
      { threshold, rootMargin },
    );
    observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold, rootMargin]);

  return (
    <motion.div
      ref={ref}
      className={`fade-in-component ${className}`}
      initial={{ opacity: 0, y: 60 }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 60 }}
      transition={{ duration, delay, ease: "easeOut" }}
      style={style}
    >
      {children}
    </motion.div>
  );
};

export default FadeInComponent;
